import { Component, Input, OnChanges } from "@angular/core";
import { planServiceTypeToShortLabel, ServiceType } from "src/services/subscription/plan-service-type.enum";
import { ApiOrderServiceType } from "../../../../../services/order/order-api.service";

@Component({
  selector: "rc-service-type-badge",
  templateUrl: "./service-type-badge.component.html",
  styleUrls: ["./service-type-badge.component.scss"],
  standalone: false,
})
export class ServiceTypeBadgeComponent implements OnChanges {
  @Input() public serviceType: ServiceType | ApiOrderServiceType;

  public color: string;

  constructor() {}

  public ngOnChanges() {
    switch (this.serviceType) {
      case ServiceType.localDelivery:
      case ServiceType.baseToBaseDelivery:
        this.color = "dodger";
        break;
      case ServiceType.firstTimePickup:
        this.color = "purple";
        break;
      case ServiceType.localPickup:
        this.color = "tertiary";
        break;
      case ServiceType.nationwideDelivery:
      case ServiceType.nationwidePickup:
        this.color = "orange";
        break;
    }
  }

  public readonly planServiceTypeToShortLabel = planServiceTypeToShortLabel;
}
